import actions, { actionCreators } from '../redux/actionCreators'

// JUST FUDGE this right now... this all will go when we map to dispatch properly for all action creators

//  Maps a list of actions to dispatch
const mapDispatchers = (dispatch, list) => {
	const result = {}
	if (!Array.isArray(list)) {
		list = Object.keys(list) // eslint-disable-line no-param-reassign
	}
	list.forEach((entry) => {
		if (actionCreators[entry]) {
			// the new style, wrap in a call to dispatch
			result[entry] = (...args) => dispatch(actionCreators[entry](...args))
		} else if (typeof actions[entry] === 'function') {
			// old style, pass dispatch to "action creator"
			result[entry] = actions[entry](dispatch)
		}
	})
	return result
}

export default mapDispatchers



// WEBPACK FOOTER //
// ./src/utilities/mapDispatchers.js